import React from "react"
import "./style.css"
interface IProps {
    value?: number // value the chart should show
    valuelabel?: string // label for the chart
    valueLabelYPosition?: number // label Y position
    size?: number // diameter of chart
    strokeWidth?: number // width of chart line
    indicatorStrokeColor?: string // color of chart line
    trackStrokeColor?: string
    textValStyle?: React.CSSProperties
    percentStyle?: React.CSSProperties
    textLabelStyle?: React.CSSProperties
    spaceBetweenValAndLabel?: number
    hidePercent?: boolean
    customValueStr?: string
    onClick?(): void
}

const DonutChart: React.SFC<IProps> = (props: IProps) => {
    const halfsize = props.size * 0.5
    const radius = halfsize - props.strokeWidth * 0.5
    const circumference = 2 * Math.PI * radius
    const strokeval = (props.value * circumference) / 100
    const dashval = strokeval + " " + circumference
    const trackstyle = {
        strokeWidth: props.strokeWidth,
        stroke: props.trackStrokeColor
    }
    const indicatorstyle = {
        strokeWidth: props.strokeWidth,
        strokeDasharray: dashval,
        stroke: props.indicatorStrokeColor
    }
    const rotateval = "rotate(-90 " + halfsize + "," + halfsize + ")"

    return (
        <svg style={{ cursor: props.onClick && "pointer" }} width={props.size} height={props.size} className="donutchart" onClick={props.onClick}>
            <circle r={radius} cx={halfsize} cy={halfsize} transform={rotateval} style={trackstyle} className="donutchart-track" />
            <circle r={radius} cx={halfsize} cy={halfsize} transform={rotateval} style={indicatorstyle} className="donutchart-indicator" />
            <text className="donutchart-text" x={halfsize} y={halfsize} style={{ textAnchor: "middle" }}>
                <tspan className="donutchart-text-val" style={props.textValStyle} y={props.valueLabelYPosition}>{props.customValueStr === undefined ? props.value : props.customValueStr}</tspan>
                {!props.hidePercent &&
                    <tspan className="donutchart-text-percent" style={props.percentStyle}>%</tspan>
                }
                <tspan className="donutchart-text-label" style={props.textLabelStyle} x={halfsize} y={props.spaceBetweenValAndLabel ? halfsize + props.spaceBetweenValAndLabel : halfsize + 15}>
                    {props.valuelabel}
                </tspan>
            </text>
        </svg>
    )
}

DonutChart.defaultProps = {
    value: 0,
    valuelabel: "Donut Chart",
    size: 116,
    strokeWidth: 26,
    indicatorStrokeColor: "#4CAF50",
    trackStrokeColor: "#DAE2E5"
}
export default DonutChart
